import { render, staticRenderFns } from "./ConfirmActive.vue?vue&type=template&id=65b22cce&scoped=true&"
import script from "./ConfirmActive.vue?vue&type=script&lang=js&"
export * from "./ConfirmActive.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmActive.vue?vue&type=style&index=0&id=65b22cce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b22cce",
  null
  
)

export default component.exports